import { Link } from 'react-router-dom'

export function Deploy() {
  return (
    <div className="page">
      <h1 className="section-title">部署专区</h1>
      <p className="lead" style={{ marginBottom: '2rem' }}>
        按环境选择：本地安装（Win/Mac）、云端一键（Hostinger/腾讯云）、Docker 进阶。
      </p>

      <div className="card">
        <h2>本地安装</h2>
        <ul>
          <li><strong>Mac：</strong>Node.js 22+ → <code>npm install -g openclaw</code> → <code>openclaw onboard</code></li>
          <li><strong>Windows：</strong>建议先配置 WSL2，在 WSL 内按 Linux 方式安装；或使用 Docker Desktop。详见「安全与排障」→ WSL2 配置。</li>
        </ul>
      </div>

      <div className="card">
        <h2>云端一键</h2>
        <p>Hostinger、腾讯云 Lighthouse 等提供带 OpenClaw 的一键 Docker 镜像。在控制台按指引填写 API Key 与通道配置即可，无需本地环境。</p>
      </div>

      <div className="card">
        <h2>Docker 进阶</h2>
        <p>必须配置 <code>shm_size: '2gb'</code> 以防 Chromium 崩溃，并开放 <code>18789</code> 端口。示例：</p>
        <pre className="code-block">{`services:
  openclaw:
    image: openclaw/openclaw:latest
    shm_size: '2gb'
    ports:
      - "18789:18789"
    # 环境变量与卷挂载见官方文档`}</pre>
      </div>

      <div className="card">
        <h2>场景专用指南</h2>
        <p>按「你想解决什么问题」查看端到端配置与提示词：</p>
        <ul className="guide-links">
          <li><Link to="/guides/developer">全自动代码与运维助手 (Developer/DevOps)</Link></li>
          <li><Link to="/guides/enterprise">国内企业协同办公助理 (飞书等)</Link></li>
          <li><Link to="/guides/research">深度信息检索与私人大脑</Link></li>
          <li><Link to="/guides/smart-home">智能家居中枢</Link></li>
        </ul>
      </div>
    </div>
  )
}
